import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import { useTranslation } from "react-i18next";
import AutoForm from "../form/functional/AutoForm";
import getSchema from "../../lib/api/getSchema";
import {debounce, cloneDeep} from "lodash";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import BasicCrudScreenHeaderLayout from "../screenTypes/layout/BasicCrudScreenHeaderLayout";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";
import BizPlaceUpdateButton from "../input/BizPlaceUpdateButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import BizPlaceCreateButton from "../input/BizPlaceCreateButton";
import AutoFormViewLayout from "../form/layout/AutoFormViewLayout";

const id = "BizPlace";
const table = "BizPlace";
const view = "VwBizPlace";

function tableModifySchema(schema, type = 'create') {
    for (const column of schema.columns) {
      if (column.name === 'bizCode' && type === 'create') {
        delete column.key;
        column.readonly = false;
      } 
    }
}

function readOnlyModifySchema(schema)  {
    schema.columns.forEach(column =>{
        column.disabled = true;

        if(column.required) {
            column.required = false;
        }

    });
}

function BizPlace ( props ) {

    const { t } = useTranslation();

    const [createTableSchema, setCreateTableSchema]  = useState();
    const [readOnlyTableSchema, setReadOnlyTableSchema]  = useState();
    const [commonTableSchema, setCommonTableSchema] = useState();

    const [grid, setGrid] = useState();

    const [handleSelect, setHandleSelect] = useState();

    const [api, setApi] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const [isEmpty, setIsEmpty] = useState();


    useEffect(() => {

        let mounted = true;

        window.addEventListener('resize', handleResize);
        handleResize();

        (async () => {

            let schema = await getSchema(table);
            let createTableSchema = cloneDeep(schema);
            tableModifySchema(createTableSchema, 'create');
            let commonTableSchema = cloneDeep(schema);
            tableModifySchema(commonTableSchema, 'update');
            let readOnlySchema = cloneDeep(schema);
            readOnlyModifySchema(readOnlySchema);

            if ( mounted ) {
                setReadOnlyTableSchema(readOnlySchema);
                setCreateTableSchema(createTableSchema);
                setCommonTableSchema(commonTableSchema);
            }

        })();

        return ( () => {
            mounted = false;
            window.removeEventListener('resize', handleResize);
        } );


    }, []);

    useEffect(() => {

        if (grid) {

            grid.selectionChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems && grid.selectedItems[0]) {

                    setHandleSelect(grid.selectedItems[0])

                } else {

                    setHandleSelect([]);

                };

            }, 10));

            grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems && grid.selectedItems[0]) {

                    setHandleSelect(grid.selectedItems[0])

                } else {

                    setHandleSelect([]);

                };

            }, 10));
        }

    }, [grid])

    const [height, setHeight] = useState(0);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

   return (
        <div style={{ height: height }} >
            <ReflexContainer orientation="vertical">
            <ReflexElement flex={0.25}>
                <BasicCrudScreenType 
                    id={id}
                    table={table}
                    view={view}
                    headerTitle={t("term.bizPlace")}
                    onInitialized={(grid)=> setGrid(grid)}
                    onApiInitialized={(api)=> setApi(api)}
                    onLoadData = {(data)=> {
                        setIsEmpty(data.length < 1 ? true : false)
                    }}
                    noCreate
                    noEdit
                    noDelete
                    noExcel
                />
            </ReflexElement>
            <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />
            <ReflexElement flex={0.75}>

            <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">
                <BasicCrudActionsLayout>
                    <ToolbarFlexSpacer xs />
                    <BasicCrudScreenActionItemLayout>
                        <BizPlaceCreateButton
                            id={id}
                            schema={createTableSchema}
                            refresh={api}
                            onSuccess={onSuccess}
                        />
                    </BasicCrudScreenActionItemLayout>
                    <BasicCrudScreenActionItemLayout>
                        <BizPlaceUpdateButton
                            id={id}
                            schema={commonTableSchema}
                            grid={grid}
                            refresh={api}
                            onSuccess={onSuccess}
                            disabled = {isEmpty}
                        />
                    </BasicCrudScreenActionItemLayout>
                    <BasicCrudScreenActionItemLayout>
                        <DeleteRecordButton
                            id={id}
                            schema={commonTableSchema}
                            grid={grid}
                            color="secondary"
                            refresh={api}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                            disabled = {isEmpty}
                        />
                    </BasicCrudScreenActionItemLayout>
                </BasicCrudActionsLayout>
                    <AutoFormViewLayout>
                        <AutoForm
                            schema = {readOnlyTableSchema}
                            mode = "edit"
                            initialData = {{...handleSelect}}
                            onChange = {()=>{}}
                        />
                    </AutoFormViewLayout>
            </BasicCrudScreenHeaderLayout>
           
            </ReflexElement>
            </ReflexContainer>
        </div>
    )
}

export default BizPlace;

